import { faEnvelope, faFile, faFilePen , faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export const Home = (data) => {
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const {t}=useTranslation();
  return {
    label: t('resource_1:dashboard'),
    labelDisable: true,
    children: [
      data?.rbacDetails?.blDashboard === 'Y' && {
        name: t('resource_2:blDashboard'),
        icon: 'chart-pie',
        to: `${APP_PATH_PREFIX}/home`,
        active: true,
      },
      data?.rbacDetails?.invDashboard === 'Y' && {
        name: t('resource_2:invoiceDashboard'),
        to: `${APP_PATH_PREFIX}/payment`,
        active: false,
        icon: 'shopping-cart',
      },
      data?.rbacDetails?.instructionDashboard === 'Y' && {
        name: t("resource_1:instruction"), 
        to: `${APP_PATH_PREFIX}/instruction`,
        active: true,
        icon: 'book',
      },
      data?.rbacDetails?.registrationMstDashboard === 'Y' && {
        name: t('resource_2:registrationMaster'),
        to: `${APP_PATH_PREFIX}/registrationmaster`,
        active: true,
        icon: 'file-pen',
      },
      data?.rbacDetails?.payDetailsDashboard === 'Y' && {
        name: t('resource_2:paymentDetails'),
        to: `${APP_PATH_PREFIX}/paymentDashboard`,
        active: false,
        icon: 'pay',
      },
        data?.rbacDetails?.truckMasterDashboard === 'Y'   && {
        name: t('resource_3:truckMasterDashboard'),
        to: `${APP_PATH_PREFIX}/truckMasterDashboard`,
        active: false,
        icon: 'truck',
      },
      data?.rbacDetails?.pdfParser === "Y" && {
        name: 'PDF Parsing',
        to: `${APP_PATH_PREFIX}/templateUpload`,
        active: false,
        icon: 'template',
      }, 
      data?.rbacDetails?.paymentDashboard === 'Y' && {
        name: t("resource_1:transactions"),
        to: `${APP_PATH_PREFIX}/payment-fund`,
        active: false,
        icon: 'credit-card',
      },
      data?.rbacDetails?.standingInstDashboard === 'Y' && {
        name: t('resource_2:standingInstruction'),
        to: `${APP_PATH_PREFIX}/standing`,
        active: false,
        icon: 'list-ul',
      },
      data?.rbacDetails?.reportDashboard === 'Y' && {
        name: t('resource_1:report'),
        to: `${APP_PATH_PREFIX}/report`,
        active: false,
        icon: 'report',
      },
      data?.rbacDetails?.receiptDashboard === 'Y' && {
        name: t('resource_1:receipt'),
        to: `${APP_PATH_PREFIX}/receipt`,
        active: false,
        icon: 'receipt',
      },
      data?.rbacDetails?.emailDashboard === 'Y' && 
      {
        name: t('resource_2:emailDashboard'),
        to: `${APP_PATH_PREFIX}/emailDashboard`,
        active: false,
        icon: 'emailDashboard',
      },
       data?.rbacDetails?.payorDashboard === 'Y' && 
      {
        // name: t('resource_2:emailDashboard'),
        name: "Export BL Dashboard",
        to: `${APP_PATH_PREFIX}/exportBlDashboard`,
        active: false,
        icon: 'chart-pie',
      },
      data?.rbacDetails?.mappingDashboard === 'Y' && {
        name: t('resource_2:customerMapping'),
        to: `${APP_PATH_PREFIX}/mappingdashboard`,
        active: false,
        icon: 'user-plus',
      },
      data?.rbacDetails?.sezDashboard === 'Y' && {
        name: t('resource_3:sez_dashboard'),
        to: `${APP_PATH_PREFIX}/sezDashboard`,
        active: false,
        icon: faFileInvoice,
      },
      data?.rbacDetails?.sezInvoiceUpload === 'Y' && {
        name: t('resource_3:sez_Analytics'),
        to: `${APP_PATH_PREFIX}/sezAnalytics`,
        active: false,
        icon: 'chart-pie',
      },
      data?.rbacDetails?.sezInvoiceUpload === 'Y' && {
        name: t('resource_3:sez_Reports'),
        to: `${APP_PATH_PREFIX}/sezReports`,
        active: false,
        icon: 'report',
      },
      data?.rbacDetails?.gateInGateOutDashboard === 'Y' &&
       {
        name: t('resource_2:gateInOut'),  
        to: `${APP_PATH_PREFIX}/gateinout`,
         active: false,
        icon: 'gateinout',
     },
         data?.rbacDetails?.bulkPaymentDashboard === 'Y' && {
        name: t('resource_3:bulkpaymentDetails'),
        to: '/bulkpaymentDashboard',
        active: false,
        icon: 'pay',
      },
     (data?.rbacDetails?.userMgmtCreate === 'Y' ||
      data?.rbacDetails?.userMgmtView === 'Y') && {
      name: t('resource_1:users'),
      active: false,
      icon: 'user',
      to: `${APP_PATH_PREFIX}/users`,
    },
    (data?.rbacDetails?.customerCodeReq === 'Y') && {
      name: 'Customer Codes',
      active: false,
      icon: 'user',
      to: `${APP_PATH_PREFIX}/customerCode`,
    },
    data?.rbacDetails?.showEmailTemplateDashboard === 'Y' && {
      name: t('resource_3:email_template_dashboard'),
      to: `${APP_PATH_PREFIX}/emailTemplateDashboard`,
      active: false,
      icon: faEnvelope,
    },
    data?.rbacDetails?.showHelpDocumentDashboard === 'Y' && 
    {
      name: t('resource_3:docMaster'),
      to: `${APP_PATH_PREFIX}/documentManagment`,
      active: false,
      icon: faFilePen,
    },
    ].filter((i) => i),
  };
};

const getRoutes = (data) => {
  return [Home(data)];
};

export default getRoutes;
